module.exports = __webpack_public_path__ + "img/maintenance.59e43198.svg";